import { render, staticRenderFns } from "./SalarieDroitPrive.vue?vue&type=template&id=b4494072"
import script from "./SalarieDroitPrive.vue?vue&type=script&lang=js"
export * from "./SalarieDroitPrive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports